<template>
  <span @click="expanded=true" :class="{ pointer: !expanded }">
    <code style="white-space: pre-wrap" v-if="expanded">{{ contentStr }}</code>
    <span v-else>{{ shortText }}...</span>
  </span>
</template>

<script>
export default {
  name: "LongDatatableCell",
  data() {
    return {
      maxChar: 140,
      expanded: true
    }
  },
  props: {
    content: {
      required: true,
    }
  },
  mounted() {
    if(this.contentStr?.length > this.maxChar) this.expanded = false
  },
  watch: {
    shortText() {
      if(this.contentStr?.length > this.maxChar) this.expanded = false
    }
  },
  computed: {
    contentStr() {
      if (typeof this.content === 'string' || this.content instanceof String) return this.content
      return JSON.stringify(this.content, null, 2)
    },
    shortText() {
      return this.contentStr?.slice(0, this.maxChar) || ''
    }
  }
}
</script>
